window.state = {
    stores: null,
    selectedStore: null,
    selectedStoreID: null,
    attachFiles: {},
}
